export default __webpack_public_path__ + "static/media/arrowDownload.e7d19c1f.svg";